import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import {
  COMPANY_DOCUMENT_LOAD_ALL,
  COMPANY_DOCUMENT_RESET_PAGE,
  COMPANY_DOCUMENT_GRID_SORT,
  COMPANY_DOCUMENT_GRID_CURRENT_PAGE,
  COMPANY_DOCUMENT_GRID_SEARCH_TEXT,
  COMPANY_DOCUMENT_CHANGE_STATE
} from '../actionTypes';
import { hide as hideBusyIndicator, show as showBusyIndicator } from './busyIndicatorActions';
import { showAlert, clearAllAlerts } from './alertActions';
import StoresService from '../../services/StoresService';
import EnumService from '../../services/EnumService';
import { formatErrorMessage } from '../../utils/common';
import FormattedJobsite from '../../models/FormattedJobsite';
import { CompanyDocumentRes, EnumRes, JobsiteRes } from '../../proxy/proxy';
import CompanyDocumentsService from '../../services/CompanyDocumentsService';

export const refreshData = (): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
  dispatch(showBusyIndicator());
  dispatch(clearAllAlerts());
  const promises: Array<Promise<any>> = [
    CompanyDocumentsService.getAllCompanyDocuments()
  ];
  Promise.all(promises)
    .then((result) => {
      const companyDocuments: Array<CompanyDocumentRes> = result[0] || [];
      dispatch({
        type: COMPANY_DOCUMENT_LOAD_ALL,
        data: companyDocuments
      });
    }).catch((err) => {
      dispatch(showAlert(formatErrorMessage(JSON.parse(err.response))));
    }).then(() => {
      dispatch(hideBusyIndicator());
    });
};

export const reset = () => ({
  type: COMPANY_DOCUMENT_RESET_PAGE
});

export const searchByText = (text: string) => ({
  type: COMPANY_DOCUMENT_GRID_SEARCH_TEXT,
  data: text
});

export const changePage = (page = 1) => ({
  type: COMPANY_DOCUMENT_GRID_CURRENT_PAGE,
  data: page
});

export const changeSortModel = (sortModel = []) => ({
  type: COMPANY_DOCUMENT_GRID_SORT,
  data: sortModel
});

export const selectStates = (states: Array<number> = []): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
  dispatch({ type: COMPANY_DOCUMENT_CHANGE_STATE, data: states });
};
